const formatPrice = (amount: string | number | null | undefined): string => {
    try {
        if (amount === null || amount === undefined) {
            return "";
        }

        const amountString = String(amount).trim();
        if (
            amountString === "" ||
            amountString === "$-" ||
            amountString.toLowerCase() === "null" ||
            amountString.toLowerCase() === "$null" ||
            amountString.toLowerCase() === "undefined"
        ) {
            return "";
        }

        const normalizedAmount = amountString.replace("$", "").replace(/,/g, "");
        const price = parseFloat(normalizedAmount);
        if (isNaN(price)) {
            return "";
        }

        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        });
    } catch (err) {
        return "";
    }
}

export const CorrectedformatCurrency = (value: string): string => {
    if (!value) {
      return ""; // Return empty string if the input is empty
    }
  
    const numValue = parseFloat(value); // Convert string to number
  
    if (isNaN(numValue)) {
      return ""; // Return empty string if the conversion results in NaN
    }
  
    if (numValue < 0) {
      return `(${Math.abs(numValue).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      })})`;
    } else {
      return numValue.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
    }
  }

export default formatPrice;